import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAssetsConfig } from "../../methods/Methods";
import { ResponseAssetsConfig } from "../../types/common";



//-------------------------------------------------------------------------------------------------- Intefaces
export interface FillAssetsConfigSliceInterface {
    clientId: string;
};

export interface AssetsConfigData extends ResponseAssetsConfig {
    clientId: string;
};



//-------------------------------------------------------------------------------------------------- Vars and consts
const assetsConfigInitialState: AssetsConfigData = {
    clientId: "",
    showReferidos: false,
    showRecargas: false
};

//-------------------------------------------------------------------------------------------------- Thunks
const fillAssetsConfigSlice = createAsyncThunk(
    "thunk/assetsConfig",
    async (obj: FillAssetsConfigSliceInterface): Promise<AssetsConfigData> => {
        let data: AssetsConfigData = {
            clientId: obj.clientId,
            showReferidos: false,
            showRecargas: false
        };
        await getAssetsConfig(obj.clientId).then((response) => {
            if (response.data && response.data.data) {
                data.showRecargas = response.data.data[0].showRecargas;
                data.showReferidos = response.data.data[0].showReferidos;
            }
        }).catch(() => { });

        return data;
    }
);



//-------------------------------------------------------------------------------------------------- Slice
const assetsConfigSlice = createSlice({
    name: "assetsConfig",
    initialState: assetsConfigInitialState,
    reducers: {
        setAssetsConfigData: (state, action: PayloadAction<AssetsConfigData>) => {
            state.clientId = action.payload.clientId;
            state.showRecargas = action.payload.showRecargas;
            state.showReferidos = action.payload.showReferidos;
        },
        clearAssetsConfigData: (action) => {
            action.clientId = assetsConfigInitialState.clientId;
            action.showRecargas = assetsConfigInitialState.showRecargas;
            action.showReferidos = assetsConfigInitialState.showReferidos;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fillAssetsConfigSlice.fulfilled, (state, action) => {
            state.clientId = action.payload.clientId;
            state.showRecargas = action.payload.showRecargas;
            state.showReferidos = action.payload.showReferidos;
        });
    }
});



//-------------------------------------------------------------------------------------------------- Exports
export { fillAssetsConfigSlice };
export const {
    setAssetsConfigData, clearAssetsConfigData
} = assetsConfigSlice.actions;
export const getAssetsConfigData = (state: any) => state.assetsConfig as AssetsConfigData;
export default assetsConfigSlice.reducer;
